import { createUseStyles } from "react-jss";

export const NotMasterDataWarningStyle = createUseStyles((theme: any) => ({
    container: {
        width: "100%",
    },
}));
